<template>
  <q-field
      v-bind="fieldAttrs"
      @update:modelValue="modelValue = $event"
      borderless
      stack-label
      no-error-icon
      class="hide-label"
  >
    <template v-slot:control>
      <q-option-group
          v-bind="allAttrs"
      >
        <slot name="label" />
      </q-option-group>
    </template>
  </q-field>
</template>

<script>
import Base from './Base'
import OptionsMixin from './OptionsMixin'

export default {
  mixins: [OptionsMixin],
  extends: Base
}
</script>
